import { useCallback, useEffect, useRef, useState } from 'react';
import { NOT_A_PROMOTER, fetchPromoterMe } from '../../services/promoterApi';

// Perfil de promotor de una EMPRESA (token de empresa, sin segundo login).
// GET /api/promoter/me responde 403 `not_a_promoter` si la empresa aún no tiene perfil.
// Devuelve { loading, me, notAPromoter, error, refresh }.
const useEmpresaPromoterMe = (enabled) => {
  const [state, setState] = useState({ loading: enabled, me: null, notAPromoter: false, error: '' });
  const mounted = useRef(true);

  // StrictMode (desarrollo) monta, desmonta y vuelve a montar: hay que volver a marcarlo como montado
  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    try {
      const data = await fetchPromoterMe('empresa');
      if (!mounted.current) return;
      setState({
        loading: false,
        me: { promoter: data.promoter, links: data.links, canOperate: data.canOperate !== false },
        notAPromoter: false,
        error: '',
      });
    } catch (error) {
      if (!mounted.current) return;
      if (error.code === NOT_A_PROMOTER) {
        setState({ loading: false, me: null, notAPromoter: true, error: '' });
      } else {
        setState((current) => ({ ...current, loading: false, error: error.message }));
      }
    }
  }, [enabled]);

  useEffect(() => { refresh(); }, [refresh]);

  return { ...state, refresh };
};

export default useEmpresaPromoterMe;
